<template>
  <f7-page @page:init="onPageInit">
    <f7-navbar :back-link="$t('back')">
      <f7-nav-title>申请提款</f7-nav-title>
      <langButton></langButton>
    </f7-navbar>
    <f7-card class="facebook-card" outline>
      <f7-card-header class="no-border">
        <div class="facebook-name">
          {{ $field(Name) }}
        </div>
        <div class="text_red">s${{ Balance }}</div>
      </f7-card-header>
      <f7-card-content>
        <p class="text_dimgray">
          单次最低取款额$50元，每次提款间隔最少20天，系统会保留$100的入驻押金，退出平台时将可取出。提交申请后3-5个工作日内将完成放款。
        </p>
      </f7-card-content>
      <f7-card-footer>
        <div class="text_powder">
          可提：s${{
            towNumber(Balance - Freeze - 100 > 0 ? Balance - Freeze - 100 : 0)
          }}
        </div>
        <div class="text_blue">冻结：s${{ Freeze }}</div></f7-card-footer
      >
    </f7-card>
    <f7-list inset no-hairlines-md form ref="form">
      <f7-list-input
        label="提款金额"
        type="text"
        placeholder="输入提款金额"
        required
        validate
        v-model:value="addForm.Amount"
      >
      </f7-list-input>
      <f7-list-input
        label="银行名"
        type="text"
        placeholder="输入银行名"
        required
        validate
        readonly
        v-model:value="addForm.BankName"
      >
      </f7-list-input>
      <f7-list-input
        label="账号"
        type="text"
        placeholder="输入账号"
        required
        validate
        readonly
        v-model:value="addForm.Account"
      >
      </f7-list-input>
      <f7-list-input
        label="开户名"
        type="text"
        placeholder="输入开户名"
        required
        validate
        readonly
        v-model:value="addForm.AccountName"
      >
      </f7-list-input>
    </f7-list>
    <f7-block>
      <f7-button fill large :loading="isLoading" @click="addPayout">
        提交提款申请
      </f7-button>
    </f7-block>
  </f7-page>
</template>
<script>
import util from "util/date";
import { getShopPayoutInfo, sendShopPayout } from "@/api/api";
import { f7 } from "framework7-vue";
export default {
  props: {
    f7route: Object,
    f7router: Object,
  },
  data() {
    return {
      Name: "可派商城订单",
      Balance: 0,
      Freeze: 0,
      addForm: { Amount: 0, BankName: "", Account: "", AccountName: "" },
      isLoading: false,
    };
  },
  methods: {
    towNumber(val) {
      return val.toFixed(2);
    },
    addPayout() {
      if (!f7.input.validateInputs("form")) {
        return;
      }
      if (
        util.isEmt.format(this.addForm.BankName) ||
        util.isEmt.format(this.addForm.Account) ||
        util.isEmt.format(this.addForm.AccountName)
      ) {
        f7.toast
          .create({
            icon: '<i class="f7-icons">multiply</i>',
            text: "银行信息不完整请联系客户绑定银行信息",
            position: "center",
            closeTimeout: 2000,
          })
          .open();
        return;
      }
      if (this.addForm.Amount < 50) {
        f7.toast
          .create({
            icon: '<i class="f7-icons">multiply</i>',
            text: "提款额度不得低于s$50",
            position: "center",
            closeTimeout: 2000,
          })
          .open();
        return;
      }
      if (this.addForm.Amount > this.Balance - this.Freeze - 100) {
        f7.toast
          .create({
            icon: '<i class="f7-icons">multiply</i>',
            text: "余额不足",
            position: "center",
            closeTimeout: 2000,
          })
          .open();
        return;
      }
      f7.dialog.confirm(
        "提款金额:" +
          this.addForm.Amount +
          ",提交申请后3-5个工作日内将完成放款",
        "提款确认",
        () => {
          this.isLoading = true;
          let para = Object.assign({}, this.addForm);
          sendShopPayout(para).then((res) => {
            this.isLoading = false;
            if (res.data.success) {
              f7.dialog.alert("提交成功", () => {
                this.f7router.back("/ShopPayout", {
                  ignoreCache: true,
                  force: true,
                });
              });
            } else {
              f7.toast
                .create({
                  icon: '<i class="f7-icons">multiply</i>',
                  text: res.data.msg,
                  position: "center",
                  closeTimeout: 2000,
                })
                .open();
            }
          });
        }
      );
    },
    onPageInit() {
      let para = {
        key: window.localStorage.Shop_Id,
      };
      f7.preloader.show();
      getShopPayoutInfo(para).then((res) => {
        f7.preloader.hide();
        this.Name = res.data.response.Name;
        this.Balance = res.data.response.Balance;
        this.Freeze = res.data.response.Freeze;
        this.addForm = {
          Amount:
            this.Balance - this.Freeze - 100 > 0
              ? this.Balance - this.Freeze - 100
              : 0,
          ShopId: window.localStorage.Shop_Id,
          OpenId: window.localStorage.OpenId,
          BankName: res.data.response.BankName,
          Account: res.data.response.Account,
          AccountName: res.data.response.AccountName,
        };
        this.addForm.Amount = this.addForm.Amount - (this.addForm.Amount % 100);
      });
    },
  },
};
</script>